'use strict';

/**
 * Accessibility enhancements
 */

function tabFocus() {
    $(document).on('keyup', function (e) {
        if (e.key === 'Tab') {
            // $('.tabbed').removeClass('tabbed'); required for debugging, will be removed in final version
            // setTimeout(() => $(document.activeElement).addClass('tabbed'));
            if($(document.activeElement).is('.stores, .utility-link.myaccount')) {
                $('.utility-link.contact').removeClass('hover'); 
                $('.menu-utility-content').removeClass('is-open'); 
            }
            $(document.activeElement).parent().hasClass('no-sub-menu') && $('.has-sub-menu').removeClass('hover');
        }
    });


    $(document).on(
        'keydown',
        '.popular-suggestion-wrapper .product-tile-outer',
        function (e) {
            if (e.key !== 'Tab') return;

            const $tiles = $('.popular-suggestion-wrapper .product-tile-outer');
            const firstTile = $tiles.first()[0];
            const lastTile = $tiles.last()[0];

            const activeEl = this; // ✅ correct reference

            // TAB on last tile → move forward
            if (!e.shiftKey && activeEl === lastTile) {
                e.preventDefault();
                $('.search-btn-close').focus();
            }
        }
    );
}

function loginModalAccessibility() {
    let $sidePanel = $('#login-wrapper-new'); // update selector if needed

    $sidePanel.on('keydown', function (e) {
        if (e.key !== 'Tab') return;

        const $focusable = $sidePanel.find(
            'button, input, a, select, textarea, [tabindex]:not([tabindex="-1"])'
        ).filter(':visible');

        if (!$focusable.length) return;

        const first = $focusable[0];
        const last = $focusable[$focusable.length - 1];

        // Shift + Tab
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        }
        // Tab
        else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });
}

const initializeEvents = () => {// will be updated with correct selector when login modal is implemented
    $('.level-1>li.show-more-links').hasClass('active') && $('.level-1>li.show-more-links').find('a').removeAttr('tabindex');
    tabFocus();
    loginModalAccessibility();
}

$(document).ready(function() {
	const $links = $('.skip-link-text');

    // Arrow key navigation
    $links.on('keydown', function (e) {
        let index = $links.index(this);
        // Down arrow
        if (e.key === 'ArrowDown') {
			e.preventDefault();

			let nextIndex = (index + 1) % $links.length;

			$links.removeClass('active');
			$links.eq(nextIndex).addClass('active').focus();
        }

        // Up arrow
        if (e.key === 'ArrowUp') {
			e.preventDefault();

			let prevIndex = (index - 1 + $links.length) % $links.length;

			$links.removeClass('active');
			$links.eq(prevIndex).addClass('active').focus();
        }
    });

    // on click of skiplink management
    $links.on('click keydown', function (e) {
		if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') {
			return;
		}
        e.preventDefault(); // prevent scroll down

        const $element = $(this);
        const targetID = $element.attr('href');
        let $target = $(targetID);
        let $redirectUrl, $offsetTop = 50;
        switch(targetID) {
            case "openSearch":
                $('.search-text.search-text-mobile').trigger("click");
                break;
            case "openMenu":
                const $menuItem = $(".menu-list ul li.has-sub-menu");
                $menuItem.first().find(".level-1-link").focus();
                $(".home-icon-container").attr("tabindex", "0").focus();
                break;
            case "openAccount":
                if(window.User.isCustomerAuthenticated) {
					$redirectUrl = $(".user-links li:first-child a").attr("href");
					window.location.href = $redirectUrl;
				} else {
                    $(".myaccount").trigger("click");
                    $(".login-form-content-new .username").focus();
                }
                break;
            case "openCart":
            case "openHome":
            case "openContact":
                $redirectUrl = $element.attr('data-href');
			    window.location.href = $redirectUrl;
                break;
            case "openOptions":
                if($(".promo-list").length) {
                    $target = $(".promo-list");
                } else {
                    $target = $("#cs-add-to-cart");
                }
                $offsetTop = 200;
                $target = $(".product-price-details button");
                break;
            case "openShipping":
                $offsetTop = 200;
                $target = $(".cart-checkout-button");
                break;
            case "#pdp-accordion":
                $offsetTop = 200;
                $target = $("#pdp-accordion .accordion-item").first().attr("tabindex", "0");
                break;
            case ".search-result-content": 
                $offsetTop = 300;
                break;
            default:
                break;
        }
		
        $links.removeClass('active');
        setTimeout(function() {
			$(".nav-assist-container li:first-child a").addClass('active');
		    $('.nav-assistant').removeClass('focused-skiplinks'); // hide skiplinks on click of links
		}, 100);

        // scroll to active target
        if($target.length) {
            window.scrollTo({
                top: $target.offset().top - $offsetTop,
                behavior: 'smooth'
            });
            if(targetID == "footer") {
                $(".newsletter-form-container .email").focus();
            } else {
                $target.focus();  // Accessibility focus handling
            }
        }
    });

	// Close skiplinks on Escape and Tab click
	$(document).on('keydown', function (e) {
		// Always allow Escape to close
		if (e.key === 'Escape') {
			$('.nav-assistant').removeClass('focused-skiplinks');
			return;
		}

		// Handle Tab only for keyboard navigation
		if (e.key === 'Tab') {
			setTimeout(function () {
				const $focused = $(document.activeElement);
				// Keep open if focus is still inside skiplinks
				if ($focused.closest('.nav-assistant').length === 0) {
					$('.nav-assistant').removeClass('focused-skiplinks');
				}
			}, 0);
		}
	});
});

$('.nav-assistant a').on('focus', function () {
    $('.nav-assistant').addClass('focused-skiplinks');
});

$('.nav-assistant a').on('blur', function () {
    // wait for next focused element
    setTimeout(function () {
        if (!$('.nav-assistant').find(':focus').length) {
            $('.nav-assistant').removeClass('focused-skiplinks');
        }
    }, 0);
});


export default {
    init: function () {
        initializeEvents();
    }
};
